import React, { useEffect, useState } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import UsersListLayer from "../components/UsersListLayer";
import TrucksPageLayer from "./TrucksPageLayer";
import { API_URL } from "..";
import { Button, Modal } from "react-bootstrap";
import { Icon } from "@iconify/react";
import {Spinner} from 'react-bootstrap'
const TrucksPage = () => {
    const [jobsData,setJobsData] = useState([])
    const fetchTrucks = async ()=>{
      setIsLoading(true)
        const value = JSON.parse(localStorage.getItem('user'));
        const apiCall = await fetch(`${API_URL}/api/truck/${value.id}`, {method : 'GET'});
        const response = await apiCall.json();
        if(apiCall.status === 200){
          setIsLoading(false)
          setJobsData(response.truck)
        }else{
          setIsLoading(false)
        }
    }
    useEffect(()=>{
        fetchTrucks()
    },[1])
    const [modal,setModal] = useState(false);
    const [newTruck,setNewTruck] = useState(false)
    const [isLoading,setIsLoading] = useState(false)
   
    const [showMessage,setShowMessage] = useState({
        show: false,
        message: '',
        type: 'error'
       })
    const [truckData,setTruckData] = useState({
        name:'',
        type: 'Unspecified',
        duty:'Unspecified',
      })
    const addTruckIntoDB = async (event)=>{
        const value = JSON.parse(localStorage.getItem('user'))
  
        event.preventDefault()
        if(truckData.name == ''){
          setShowMessage({
            show: true,
            message: 'Truck name is required',
            type: 'error'
           })
          return false;
        }else{
          let body = JSON.stringify({
            name : truckData.name,
            type: truckData.type,
            duty: truckData.duty,
            affiliate_id : value.id
          })
          const apiCall = await fetch(
            `${API_URL}/api/truck/create`, {
              body :body,
              method :'POST',
              headers:{
                'Content-Type' : 'application/json',
              }
            }
           )
           const response = await apiCall.json();
           if(apiCall.status === 200){
            setShowMessage({
              show: true,
              message: 'You successfully added the truck',
              type: 'success'
             })
             setModal(false)
             setNewTruck(false);
             window.location.reload()
             setTruckData({
                name:'',
                type:'Unspecified',
                duty:'Unspecified',
             })
           }else{
            setShowMessage({
              show: true,
              message: 'Error while adding the truck. Please try again',
              type: 'error'
             })
           }
  
        }
  
      }
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Trucks" />
        {isLoading && (
    <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(255, 255, 255, 0.8)',
        zIndex: 9000,
        borderRadius: '12px'
    }}>
        <Spinner
            animation="border" 
            role="status"
            variant="info"
            style={{ width: '3rem', height: '3rem' }}
        >
            <span className="visually-hidden">Loading...</span>
        </Spinner>
    </div>
)}
         
        {/* UsersListLayer */}
        {
           isLoading === true && jobsData.length == 0 ? null :
           <>
           
           <div className="card basic-data-table">
          <div className="card-header">
            <div className="row">
              <h5 className="col-md-6 card-title mb-0">Trucks</h5>
              <div className="col-md-6 text-end">
              <button type="button" onClick={()=>setModal(true)} className="btn btn-primary">Add New</button>
              </div>
            </div>
          </div>
          </div>
            <TrucksPageLayer jobsData={jobsData}/>
           </>
            
            
        }

       
     <Modal show={modal} centered onHide={()=>setModal(false)}>
        <Modal.Header closeButton>

        <Modal.Title className="small-title" >
                <h6>Add Truck</h6>
        </Modal.Title>
        </Modal.Header>
        <Modal.Body>
        
            <div className='col-md-12'>
               {showMessage.show === true ? (
                          <div
                            className={
                              showMessage.type == "error"
                                ? "mt-3 alert alert-danger bg-danger-50 text-danger-600 border-danger-50 px-24 py-11 mb-0 fw-semibold text-lg radius-8 d-flex align-items-center justify-content-between mb-10"
                                : "mt-3 alert alert-success bg-success-50 text-success-600 border-success-50 px-24 py-11 mb-0 fw-semibold text-lg radius-8 d-flex align-items-center justify-content-between mb-10"
                            }
                            role="alert"
                          >
                            {showMessage.message}
                            <button
                              type="button"
                              onClick={() =>
                                setShowMessage((prev)=>({...prev, show: false}))
                              }
                              className="remove-button text-secondary-600 text-xxl line-height-1"
                            >
                              {" "}
                              <Icon
                                icon="iconamoon:sign-times-light"
                                className="icon"
                              />
                            </button>
                          </div>
                        ) : null}
            <form onSubmit={addTruckIntoDB} >
                    
                    <div className='row'>
                      <div className='col-md-12'>
                    <div className="mb-20">
                      <label
                        htmlFor="name"
                        className="form-label fw-semibold text-primary-light text-sm mb-8"
                      >
                        Name <span className="text-danger-600">*</span>
                      </label>
                      <input
                        type="text"
                        name="name"
                        value={truckData.name}
                        onChange={(e)=>setTruckData((prev)=>({...prev, name : e.target.value}))}
                        className="form-control radius-8"
                        id="name"
                        
                        
                      />
                    </div>
                    </div>
                    <div className='col-md-12'>
                    <div className="mb-20">
                      <label
                        htmlFor="truck_type"
                        className="form-label fw-semibold text-primary-light text-sm mb-8"
                      >
                        Type
                      </label>
                       <select
                        className="form-control radius-8"
                        id="truck_type"
                        name="truck_type"
                        value={truckData.type}
                        onChange={(e)=>setTruckData((prev)=>({...prev, type : e.target.value}))}
                        >
                          
                          <option value={'Unspecified'}>Unspecified</option>
                          <option value={'Wrecker'}>Wrecker</option>
                          <option value={'Flat Bed'}>Flat Bed</option>
                          <option value={'Other'}>Other</option>
                          <option value={'Service Vehicle'}>Service Vehicle</option>
                          <option value={'Rotator'}>Rotator</option>
                          <option value={'Tractor'}>Tractor</option>
                          <option value={'Trailer'}>Trailer</option>
                          <option value={'Container'}>Container</option>
                          <option value={'Hazmat'}>Hazmat</option>
                        </select>
                      
                    </div>
                    </div>
                    <div className='col-md-12'>
                    <div className="mb-20">
                      <label
                        htmlFor="truck_duty"
                        className="form-label fw-semibold text-primary-light text-sm mb-8"
                      >
                        Duty
                      </label>
                       <select
                        value={truckData.duty}
                        onChange={(e)=>setTruckData((prev)=>({...prev, duty : e.target.value}))}
                        className="form-control radius-8"
                        id="truck_duty"
                        name="truck_duty"
                        >
                          <option value={'Unspecified'}>Unspecified</option>
                          <option value={'Medium'}>Medium</option>
                          <option value={'Heavy'}>Heavy</option>
                          <option value={'Other'}>Other</option>
                          <option value={'Light'}>Light</option>
                        </select>
                      
                    </div>
                    </div>
                    <div className='col-md-12 text-center'>
                   
                      <button
                        type="button"
                        onClick={()=>setModal(false)}
                        style={{marginTop: 30,marginRight: 10}}
                        className="btn btn-danger border border-danger-600 text-md px-56 py-12 radius-8"
                      >
                        Close
                      </button>
                      <button
                        type="submit"
                        style={{marginTop: 30}}
                        className="btn btn-primary border border-primary-600 text-md px-56 py-12 radius-8"
                      >
                        Save
                      </button>
                    
                    </div>
                    </div>
                   
                  
                  
                 
                  </form>
            </div>
        </Modal.Body>
     </Modal>
      </MasterLayout>

    </>
  );
};

export default TrucksPage; 
